import { getAuthData } from "../auth/session.js";

export async function gameRequest(operation, body = {}, signal, preview = false) {
  const controller = new AbortController();
  const abort = () => controller.abort();
  signal?.addEventListener("abort", abort, { once: true });
  if (signal?.aborted) abort();
  const timer = setTimeout(abort, 15000);
  try {
    const response = await fetch(`/api/king-of-the-hill/${operation}`, {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ...body, preview, initData: getAuthData() }), signal: controller.signal,
    });
    let data;
    try { data = await response.json(); } catch { throw new Error("Сервер режима недоступен. Попробуйте позже."); }
    if (!response.ok) {
      const error = new Error(data.error || "Не удалось выполнить действие.");
      error.status = response.status;
      throw error;
    }
    const state = operation === "action" ? data.state : data;
    if (["game", "action"].includes(operation) && (!state || !Array.isArray(state.nodes) || !state.player || !state.objective || !state.balance || !state.district)) {
      throw new Error("Сервер вернул неполное состояние режима.");
    }
    return data;
  } finally { clearTimeout(timer); signal?.removeEventListener("abort", abort); }
}
